import { WizardStep } from '../constants/types';

export interface WizardStepContentProps {
    step: WizardStep;
}

/** Content area for WizardModal: the active step's content (its header is shown in StandardModal's top bar). */
export const WizardStepContent = ({ step }: WizardStepContentProps) => {
    return (
        <div className='wizardStepContent'>
            <div className='wizardStepContent-body'>{step.content}</div>
        </div>
    );
};
